import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useStore = create(
  persist(
    (set) => ({
      // Cart state
      cart: [],

      // Add item to cart - merge duplicates (same product, size, color)
      addToCart: (product) => set((state) => {
        const existingItem = state.cart.find(
          item => item.id === product.id &&
                   item.size === product.size &&
                   item.color === product.color
        );

        if (existingItem) {
          // Merge with existing item - increase quantity
          return {
            cart: state.cart.map(item =>
              item.cartId === existingItem.cartId
                ? { ...item, quantity: (item.quantity || 1) + (product.quantity || 1) }
                : item
            )
          };
        } else {
          // Add new item
          return {
            cart: [...state.cart, { ...product, cartId: Date.now() }],
          };
        }
      }),

      // Remove item from cart
      removeFromCart: (cartId) => set((state) => ({
        cart: state.cart.filter(item => item.cartId !== cartId),
      })),

      // Update cart item quantity
      updateCartQuantity: (cartId, quantity) => set((state) => ({
        cart: state.cart.map(item =>
          item.cartId === cartId ? { ...item, quantity } : item
        ).filter(item => item.quantity > 0),
      })),

      // Clear cart
      clearCart: () => set({ cart: [] }),

      // Get cart total
      getCartTotal: () => 0,

      // Products
      products: [],
      setProducts: (products) => set({ products }),

      // Filters
      selectedCategory: 'all',
      setSelectedCategory: (category) => set({ selectedCategory: category }),

      // Search
      searchQuery: '',
      setSearchQuery: (query) => set({ searchQuery: query }),

      // Cart notification
      cartNotification: null,
      showCartNotification: (notification) => set({ cartNotification: notification }),
      clearCartNotification: () => set({ cartNotification: null }),

      // Currency
      selectedCurrency: 'USD',
      setSelectedCurrency: (currency) => set({ selectedCurrency: currency }),
    }),
    {
      name: 'huhua-store',
      partialState: {
        cart: true,
        selectedCurrency: true,
      },
    }
  )
);
